import React, { Component } from "react";
import { Card, Form, Row, Col } from "react-bootstrap";
import Select from 'react-select';
import AscModal from "../Modal/Modal";
import InlineForm from "../FromGroup/InlineForm";
import "./AlarmSettingModal.css";

export default class AlarmSettingModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCategories: props.selectedCategories || [],
            incomingEnabled: props.incomingEnabled !== undefined ? props.incomingEnabled : true,
            outgoingEnabled: props.outgoingEnabled !== undefined ? props.outgoingEnabled : true,
            categoryAll: props.categoryAll !== undefined ? props.categoryAll : false,
            show: props.show || false,
            modalType: "setting"
        };
    }

    /**
     * カテゴリ選択変更処理
     */
    handleCategoryChange = (selectedOptions) => {
        const selectedValues = selectedOptions || [];
        
        // 全選択が含まれているかを確認
        const hasAllOption = selectedValues.find(option => option.value === 'all');
        
        if (hasAllOption) {
            // 全選択が選択された場合
            this.setState({
                categoryAll: true,
                selectedCategories: []
            });
        } else {
            // 個別カテゴリ選択の場合
            this.setState({
                categoryAll: false,
                selectedCategories: selectedValues
            });
        }
    };

    /**
     * 発着信設定変更処理
     */
    handleCallTypeChange = (type, checked) => {
        this.setState({
            [type]: checked
        });
    };

    /**
     * 設定保存処理
     */
    handleSave = () => {
        const settings = {
            categories: this.state.selectedCategories,
            categoryAll: this.state.categoryAll,
            incoming: this.state.incomingEnabled,
            outgoing: this.state.outgoingEnabled
        };
        this.props.onSave(settings);
    };

    /**
     * バリデーション（常にtrue）
     */
    validationHandle = () => {
        return true;
    };

    /**
     * プロップス更新時のstate同期
     */
    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show) {
            this.setState({
                show: this.props.show,
                selectedCategories: this.props.selectedCategories || [],
                incomingEnabled: this.props.incomingEnabled !== undefined ? this.props.incomingEnabled : true,
                outgoingEnabled: this.props.outgoingEnabled !== undefined ? this.props.outgoingEnabled : true,
                categoryAll: this.props.categoryAll !== undefined ? this.props.categoryAll : false,
            });
        }
    }

    /**
     * カスタムオプション表示（カテゴリの色表示）
     */
    formatOptionLabel = (option) => {
        const { categoryAll } = this.state;
        
        // 全選択オプションの場合 基本テキストスタイル適用
        if (option.value === 'all') {
            return (
                <div className="option-container">
                    <span className="option-text-all">
                        {option.label}
                    </span>
                </div>
            );
        }
        
        // 全選択が選択された状態では他のオプションを暗く表示
        const isDisabled = categoryAll;
        const opacity = isDisabled ? 0.4 : 1;
        const backgroundColor = isDisabled ? '#6c757d' : option.color;
        
        // 通常カテゴリの場合 基本バッジスタイル適用
        return (
            <div className="option-container-with-opacity" style={{ opacity }}>
                <span
                    className="option-badge"
                    style={{
                        backgroundColor: backgroundColor,
                        color: option.font_rgb || '#ffffff'
                    }}
                >
                    {option.label}
                </span>
            </div>
        );
    };

    getCategoryOptions() {
        const { categoryList, langText } = this.props;
        return [
            { value: 'all', label: langText.Body.AllSelection, color: '#007bff' },
            ...categoryList
        ];
    }

    getSelectedValues() {
        const { categoryAll, selectedCategories } = this.state;
        const { langText } = this.props;
        if (categoryAll) {
            return [{ value: 'all', label: langText.Body.AllSelection, color: '#007bff' }];
        }
        return selectedCategories;
    }



    render() {
        const { langText } = this.props;

        return (
            <AscModal
                state={this.state}
                dialogClassName="alarm-setting-modal"
                propSetState={(newState) => {
                    if (newState.show === false) {
                        // モーダルアニメーション用に事前にstateを変更
                        this.setState({ show: false });
                        // アニメーション完了後にonHide呼び出し
                        setTimeout(() => {
                            this.props.onHide();
                        }, 150);
                    } else {
                        this.setState(newState);
                    }
                }}
                langText={langText}
                validationHandle={this.validationHandle}
                onClick={(modalType) => () => {
                    if (modalType === "setting") {
                        this.handleSave();
                    }
                }}
            >
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {langText.Header.AlarmSetting}
                        </Card.Title>
                    </Card.Header>

                    <Card.Body>
                        {/* 通話分類設定 */}
                        <InlineForm
                            key="alarm_category_setting"
                            controlId="alarm_category_setting"
                            label={langText.Body.CategorySetting}
                            labelCol={12}
                            formCol={12}
                        >
                            <Select
                                isMulti
                                closeMenuOnSelect={false}
                                options={this.getCategoryOptions()}
                                value={this.getSelectedValues()}
                                onChange={this.handleCategoryChange}
                                formatOptionLabel={this.formatOptionLabel}
                                isOptionDisabled={(option) => {
                                    // 全選択が選択された場合は他のオプションを無効化
                                    return this.state.categoryAll && option.value !== 'all';
                                }}
                                menuPortalTarget={document.body}
                                menuPlacement="bottom"
                                maxMenuHeight={400}
                                components={{
                                    MultiValue: (props) => {
                                        const { data, removeProps } = props;
                                        
                                        // 全選択の場合 基本スタイル適用
                                        if (data.value === 'all') {
                                            return (
                                                <div className="multi-value-container-all">
                                                    <span className="multi-value-text-all">
                                                        {data.label}
                                                    </span>
                                                    <span
                                                        {...removeProps}
                                                        className="multi-value-remove-all"
                                                        title={langText.Body.Delete}
                                                    >
                                                        ×
                                                    </span>
                                                </div>
                                            );
                                        }
                                        
                                        // 個別カテゴリの場合 基本バッジスタイル適用
                                        return (
                                            <div
                                                className="multi-value-container-category"
                                                style={{
                                                    backgroundColor: data.color,
                                                    color: data.font_rgb || '#ffffff'
                                                }}
                                            >
                                                <span className="multi-value-text-category">
                                                    {data.label}
                                                </span>
                                                <span
                                                    {...removeProps}
                                                    className="multi-value-remove-category"
                                                    title={langText.Body.Delete}
                                                >
                                                    ×
                                                </span>
                                            </div>
                                        );
                                    }
                                }}
                                placeholder={langText.Body.CategorySelectionPlaceholder}
                                noOptionsMessage={() => langText.Body.NoCategoryAvailable}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        minHeight: '40px'
                                    }),
                                    multiValue: () => ({
                                        margin: '0',
                                        backgroundColor: 'transparent'
                                    }),
                                    multiValueLabel: () => ({
                                        display: 'none'
                                    }),
                                    multiValueRemove: () => ({
                                        display: 'none'
                                    }),
                                    menuPortal: (provided) => ({
                                        ...provided,
                                        zIndex: 9999
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999
                                    })
                                }}
                            />
                        </InlineForm>

                        {/* 発着信設定 */}
                        <InlineForm
                            key="alarm_call_type_setting"
                            controlId="alarm_call_type_setting"
                            label={langText.Body.CallTypeSetting}
                            labelCol={12}
                            formCol={12}
                        >
                            <Row>
                                <Col xs="auto">
                                    <Form.Check
                                        type="checkbox"
                                        id="incoming-checkbox"
                                        label={langText.Body.Incoming}
                                        checked={this.state.incomingEnabled}
                                        onChange={(e) => this.handleCallTypeChange('incomingEnabled', e.target.checked)}
                                    />
                                </Col>
                                <Col xs="auto">
                                    <Form.Check
                                        type="checkbox"
                                        id="outgoing-checkbox"
                                        label={langText.Body.Outgoing}
                                        checked={this.state.outgoingEnabled}
                                        onChange={(e) => this.handleCallTypeChange('outgoingEnabled', e.target.checked)}
                                    />
                                </Col>
                            </Row>
                        </InlineForm>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
} 